const DAY_IN_SECONDS = 86400;

export default function ChunksService() {
  return {
    chunkToTimeString: chunkToTimeString,
    timeStringToChunk: timeStringToChunk,
    startTimeChunkIsNotValid: startTimeChunkIsNotValid,
    endTimeStringIsNotValid: endTimeStringIsNotValid,
  };

  function chunkToTimeString(chunk, startChunk) {
    if (chunk === null) {
      return chunk;
    }
    const duration = moment.duration(chunk, 'seconds');
    if (startChunk !== null && (startChunk >= chunk || chunk >= DAY_IN_SECONDS)) {
      duration.subtract(DAY_IN_SECONDS, 'seconds');
    }
    var hours = Math.floor(duration.as('hours'));
    var minutes = Math.floor(duration.subtract(hours, 'hours').as('minutes'));
    if (hours.toString().length < 2 && hours[0] !== '0') {
      hours = '0' + hours;
    }
    if (minutes.toString().length < 2 && minutes !== '0') {
      minutes = '0' + minutes;
    }
    return hours + ':' + minutes;
  }
  function timeStringToChunk(timeStr, startChunk) {
    var chunk = moment.duration(timeStr, 'HH:mm').as('seconds');
    if (startChunk !== null && startChunk >= chunk) {
      chunk += DAY_IN_SECONDS;
    }
    return chunk;
  }
  function startTimeChunkIsNotValid(startChunk) {
    return startChunk >= DAY_IN_SECONDS;
  }
  function endTimeStringIsNotValid(endTimeString) {
    const timeStrings = endTimeString.split(':'),
      hours = parseInt(timeStrings[0], 10),
      minutes = parseInt(timeStrings[1], 10);
    return hours >= 24 || minutes >= 60;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/chunks.service.js